import React from 'react';

export const Add = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height ?? '22px'}
    viewBox="0 0 22 22"
    width={width ?? '22px'}
    fill={color || '#000000'}
  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill={color ?? '#42526e'} />
  </svg>
);
